import React, { useState, useEffect, useMemo } from "react";
import Autocomplete from "@mui/material/Autocomplete";
import debounce from "lodash.debounce";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import parse from "autosuggest-highlight/parse";
import Grid from "@mui/material/Grid";
import Paper from "@mui/material/Paper";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import InputBase from "@mui/material/InputBase";
import IconButton from "@mui/material/IconButton";
import { SearchIconButton } from "../SearchIconButton/SearchIconButton";
import clsx from "clsx";
import css from "./AutocompleteLocalSearch.module.css";

export const AutocompleteLocalSearch = ({
  searchHandler,
  getPredictions,
  getValue,
  setValue,
  getPlace,
}) => {
  const debouncedSearchHandler = useMemo(
    () => debounce(searchHandler, 700),
    []
  );

  const [localCopy, setLocalCopy] = useState(null);

    const searcherKeyDown4 = (e) => {
        switch(e.key) {
            case 'Enter':
                if(null === localCopy) {
                    e.preventDefault();
                }
                break;
        }
    }

  return (
    <Autocomplete
        onKeyDown={searcherKeyDown4}
      id="google-map-demo"
      className={clsx(css.googleMapDemo)}
      getOptionLabel={(option) =>
        typeof option === "string" ? option : option.description
      }
      filterOptions={(x) => x}
      options={getPredictions}
      autoComplete
      includeInputInList
      filterSelectedOptions
      value={getValue}
      noOptionsText="np. Kraków PCK 12"
      onChange={(event, newValue) => {
        setValue(newValue);
        getPlace(newValue);
        setLocalCopy(newValue);
      }}
      autoHighlight
      onInputChange={debouncedSearchHandler}
      renderInput={(params) => (
        <Paper className={clsx(css.paper)} component="form">
          <Box className={clsx(css.box)}>
            <InputBase className={clsx(css.input)}
              {...params}
              ref={params.InputProps.ref}
              placeholder="Wpisz lokalizację, a znajdziemy ofertę!"
            />
          </Box>

          <IconButton className={clsx(css.iconButton)}
            type="button"
            aria-label="search"
            onClick={() => {
              getPlace();
            }}
          >
            <SearchIconButton />
          </IconButton>
        </Paper>
      )}
      popupIcon={<SearchIconButton />}
      renderOption={(props, option) => {
        const matches =
          option.structured_formatting.main_text_matched_substrings || [];

        const parts = parse(
          option.structured_formatting.main_text,
          matches.map((match) => [match.offset, match.offset + match.length])
        );

        return (
          <li {...props}>
            <Grid container alignItems="center" sx={{ borderRadius: 10 }}>
              <Grid item sx={{ display: "flex", width: 44 }}>
                <LocationOnIcon sx={{ color: "#f29a26" }} />
              </Grid>
              <Grid
                item
                sx={{
                  width: "calc(100% - 44px)",
                  wordWrap: "break-word",
                }}
              >
                {parts.map((part, index) => (
                  <Box
                    key={index}
                    component="span"
                    sx={{
                      fontWeight: part.highlight ? "bold" : "regular",
                      color:"gray",
                    }}
                  >
                    {part.text}
                  </Box>
                ))}

                <Typography variant="body2" color="var(--color-gray)">
                  {option.structured_formatting.secondary_text}
                </Typography>
              </Grid>
            </Grid>
           
          </li>
        );
      }}
    />
  );
};
